var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 70,
    viewBox: "0 0 73 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0496 30.7982V64.2594C60.0496 67.0262 57.6979 69.269 54.7971 69.269H11.647C8.74604 69.269 6.39453 67.0261 6.39453 64.2594V11.8417C6.39453 9.07415 8.74674 6.83203 11.647 6.83203H34.921L60.0496 30.7982Z",
    fill: "#BED8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 62.8912C15.4326 62.8912 13.0811 60.6483 13.0811 57.8816V5.46372C13.0809 2.69622 15.4331 0.454102 18.3335 0.454102H41.6074C45.6087 0.454102 66.736 20.6044 66.736 24.4204V57.8816C66.736 60.6484 64.3843 62.8912 61.4835 62.8912H18.3335Z",
    fill: "#DDEAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7361 24.4208V26.5399C66.7361 22.0784 62.9428 18.4605 58.265 18.4605H53.1092C50.209 18.4605 47.8568 16.2171 47.8568 13.4509V8.53349C47.8568 4.07197 44.0635 0.454102 39.3857 0.454102H41.6076C45.6083 0.454102 49.4465 1.97017 52.2753 4.66832L62.3177 14.2464C65.1464 16.9445 66.7361 20.6051 66.7361 24.4208Z",
    fill: "#BED8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6799 38.7009V53.3475C34.6799 53.9793 35.217 54.4915 35.8794 54.4915H43.9391C44.6016 54.4915 45.1386 53.9793 45.1386 53.3475V38.7009H48.5651C49.6337 38.7009 50.1689 37.4687 49.4133 36.748L41.757 29.4457C40.7366 28.4725 39.0821 28.4725 38.0617 29.4457L30.4055 36.748C29.6499 37.4687 30.1851 38.7009 31.2536 38.7009H34.6799Z",
    fill: "#80B4FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.562 25.4262H49.2557C50.5467 25.4262 51.5931 24.4282 51.5931 23.1969V23.1356C51.5931 21.9043 50.5467 20.9062 49.2557 20.9062H30.562C29.2711 20.9062 28.2246 21.9043 28.2246 23.1356V23.1969C28.2246 24.428 29.2711 25.4262 30.562 25.4262Z",
    fill: "#80B4FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.1503,
    height: 68.8145,
    fill: "white",
    transform: "translate(0.490234 0.454102)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.bfb1bd2df40867c0d80f0ff6530b6a8b.svg";
export { ForwardRef as ReactComponent };